var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 14 14","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":_vm.iconPath,"fill":_vm.fillColor}}),(_vm.iconType === 'first' || _vm.iconType === 'last')?_c('path',{attrs:{"d":_vm.iconPathSecondary,"fill":_vm.fillColor}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }